<!-- 策划师 查询 -->
<template>
<div class="page-form">
    <PageBack :title="title" />
    <div class="detail-wrap">
        <el-form :model="searchForm" ref="searchForm"  :inline="true"> 
            <el-form-item label="姓名" prop="username">
                <el-input style="width: 200px;" v-model="searchForm.username" maxlength="10"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="phone">
                <el-input style="width: 200px;" v-model="searchForm.phone" maxlength="11"></el-input>
            </el-form-item>            
            <el-form-item label="身份证后6位" prop="identity">
                <el-input style="width: 200px;" v-model="searchForm.identity" maxlength="6"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="searchQuery('searchForm')">查询证书</el-button>
                <el-button @click="resetForm('searchForm')">重置</el-button>
                <el-button type="success" @click="handleAdd" v-if="adminRoles">证书设置</el-button>
            </el-form-item>          
        </el-form>
        <el-table border :data="tableData" style="width: 100%;">
            <el-table-column  prop="index"   label="序号"   width="50" align="center"/>     
            <el-table-column  prop="username"  label="姓名" width="100"  align="center" sortable/>                
            <el-table-column  prop="phone"   label="手机号" width="120" align="center"/>
            <el-table-column  prop="identity"   label="身份证号" width="170" align="center" />
            <el-table-column  prop="certificateNo"  label="证书编号" width="150" align="center"/>
            <el-table-column  prop="certificateTypeLevel"  label="证书类型等级"  align="center"/>
            <el-table-column  prop="issueClub"  label="发证单位" align="center" />
            <el-table-column  prop="issueDateFormat" label="发证日期"  align="center" sortable/>
            <el-table-column  prop="updateIssueDate" label="更新日期"  align="center" sortable/>
            <el-table-column  fixed="right" label="操作">
                <template slot-scope="scope">
                    <el-button @click="handleUpdate(scope.row)" type="text" size="small" v-if="roles==='管理员'">更新证书</el-button>
                    <el-button @click="handleCancel(scope.row)" type="text" size="small" v-if="roles==='管理员'">取消</el-button>
                </template>
            </el-table-column>
        </el-table>
        <pagination
            style="text-align:right"
            v-show="total > 10"
            :total="total"
            :page.sync="queryParams.page"
            :limit.sync="queryParams.pagesize"
            @pagination="initData"
        />
        <AddTrainee :title="dialogTitle" 
            v-if="isShow"
            :formData="trainForm" 
            @close="closeDialog"
            ref="childComponentRef"
            @confirm="handleConfirm"></AddTrainee>
    </div>
</div>
</template>

<script>
import PageBack from '@/components/PageHeader'
import pagination  from '@/components/Pagination'
import AddTrainee from './components/addTrainDialog'
export default {
    components: {
        PageBack,
        pagination,
        AddTrainee
    },
    data() {
        return {
            isShow: false,
            searchForm:{
                username: '',
                phone: '',
                identity: ''
            },
            queryParams:{
                page: 1,
                pagesize: 10
            },
            tableData: [],
            statusOption: [],
            total: 0,
            typeOption: [],
            isDialogVisible: false,
            titleForm: '',
            trainForm: {},
            dialogTitle: ''
        }
    },
    computed: {
        title() {
            return this.$route.meta.title
        },
        roles(){
            return localStorage.getItem('roles')
        }, 
        adminRoles(){
            let value = localStorage.getItem('roles')
            if(value === '管理员'){
                return true
            }else{
                return false
            }            
        }, 
    },
    created() {
        this.getType()
    },
    mounted() {
        
    },
    methods: {
        getType(){
            let params = {
                opcode: this.$code.SystemCode,
                v_parent_name: '',
                i_no: 107,
            }
            this.$api._requestAPI(params).then(res =>{
                if(res.IsSuccess){
                    let arr= res.Data.DataTable
                    this.typeOption = arr.map(item=>{
                        return{
                            label: item['中文描述'],
                            value: item['词条索引']
                        }
                    })
                }
            })
        },
        initData(){
            let params = {
                opcode: this.$code.certificateQuery,
                v_name: this.searchForm.username,
                v_phone: this.searchForm.phone,
                v_identity_card: this.searchForm.identity,
                pagesize: this.queryParams.pagesize,
                page: this.queryParams.page
            }

            this.$api._requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let arr = res.Data.DataTable
                    this.total = res.Data.SumCount
                    if(arr.length > 0){
                        this.tableData = arr.map(item=>{
                            return{
                                index: item['序号'],
                                username: item['学员名称'],
                                userId: item['学员账号'],
                                phone: item['手机号'],
                                certificateLevel: item['证书等级'],
                                certificateNo: item['证书编号'], 
                                identity: item['身份证号码'],  
                                issueClub: item['发证单位'], 
                                issueDateFormat: this.$help.formatDate(item['发证日期']), 
                                issueDate: item['发证日期'], 
                                updateIssueDate: this.$help.formatDate(item['更新日期']), 
                                imageUrl: item['2寸彩色照片'],
                                status: item['状态'],
                                certType: item['证书类型'],
                                certificateTypeLevel: this.certTypeToText(item['证书类型']) + item['证书等级']
                            }
                        })
                    }else{
                        this.tableData = []
                    }
                }
            })

        },
        searchQuery(){            
            if(this.roles === '管理员'){
                this.initData()
            }else{
                if(this.searchForm.username && this.searchForm.phone && this.searchForm.identity){
                    this.initData()
                }else{
                    this.$message.error('请输入姓名、手机号、身份证后6位！')
                }
            }
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        handleAdd(){
            this.isShow = true
            // this.isDialogVisible = true
            this.dialogTitle = '证书设置'
            this.trainForm = {}
        },
        // 更新证书
        handleUpdate(obj){           
            // this.$router.push({
            //     name: "traineeSetting",
            //     params: {
            //         obj: obj,
            //     }
            // })
            this.isShow = true
            this.dialogTitle = '更新证书'
            this.trainForm = obj
        },
        // 取消证书
        handleCancel(obj){
            this.$confirm('确定取消吗？取消后证书将作废','警告',).then(res=>{
               this.confirmCancel(obj)
            }).catch(err=>{
                console.log(err)
            })
        },
        confirmCancel(obj){
            let { username,userId,phone,certificateLevel,certificateNo, 
                    identity,  issueClub, issueDate, issueTime, imageUrl,index,certType } = obj
            let params = {
                opcode: this.$code.traineeSetting,
                v_student_name: username,
                v_phone: phone,
                i_student_no: userId,
                i_flag: 3,
                i_number: index,
                v_certificate_no: certificateNo,
                v_certificate_level: certificateLevel,
                v_issue_unit: issueClub,
                c_issue_date: issueDate,
                c_issue_time: issueTime,
                v_identity_card: identity,
                v_identity_image: imageUrl,
                i_remark: certType
            }
            // console.log(params)
            this.$api.requestAPI(params).then(res =>{
                if(res.IsSuccess){
                    this.$message.success('取消成功')
                    this.initData()            
                }else{
                    this.$message.error(res.Message)
                }
            })
        },
        certTypeToText(value){
            let name = ''
            let arr  = this.typeOption.filter(i=>i.value === value)
            name= arr[0].label
            return name
        },
        handleConfirm(){
            this.initData()
        },
        closeDialog(){
            this.isShow = false
        }
     }
}
</script>
<style lang='scss' scoped>
@import '@/assets/css/style.scss';
</style>


// WEBPACK FOOTER //
// src/views/traineeManage/traineeQuery.vue